import React from 'react';
import CheckoutData from 'components/molecules/checkout_data';

const Checkout: React.FC = () => {
  return (
    <div className="page-container">
      <CheckoutData />
    </div>
  );
};
export { Checkout };
